import { render } from "./AppNotificationDropdown.vue?vue&type=template&id=0a709ccc"
import script from "./AppNotificationDropdown.vue?vue&type=script&lang=js"
export * from "./AppNotificationDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__